import { openDB } from "./indexedDb";
import { onsiteAPI } from "../components/api";

export async function savePatientOffline(patientData) {
  console.log("💾 Saving patient offline…", {
    patientId: patientData.patient_id
  });

  const db = await openDB();

  return new Promise((resolve, reject) => {
    const tx = db.transaction("patients", "readwrite");
    const store = tx.objectStore("patients");

    store.put({
      ...patientData,
      camp: patientData.camp_id,
      package: patientData.package_id,
      technician: patientData.technician_id,
      synced: 0,
      createdAt: Date.now()
    });

    tx.oncomplete = () => {
      console.log("✅ Patient saved offline successfully");
      resolve();
    };

    tx.onerror = () => {
      console.error("❌ Failed to save patient offline", tx.error);
      reject(tx.error);
    };
  });
}

// In patientOffline.js — modify syncPatients to return synced count
export async function syncPatients() {
  const db = await openDB();

  const unsyncedPatients = await new Promise((resolve, reject) => {
    const tx = db.transaction("patients", "readonly");
    const store = tx.objectStore("patients");
    const index = store.index("synced");
    const request = index.getAll(0);
    request.onsuccess = () => resolve(request.result);
    request.onerror = () => reject(request.error);
  });

  let syncedCount = 0;
  console.log("🔄 Starting patient sync...");
  for (const patient of unsyncedPatients) {
    try {
      const {
        id,
        synced,
        createdAt,
        ...cleanPayload
      } = patient;

      // 🔥 FIX: Map back to original keys
      const payload = {
        ...cleanPayload,
        camp_id: patient.camp,
        package_id: patient.package,
        technician_id: patient.technician
      };

      console.log("📤 Sending payload:", payload);

      await onsiteAPI.addPatient(payload);

      const updateTx = db.transaction("patients", "readwrite");
      const store = updateTx.objectStore("patients");

      store.put({
        ...patient,
        synced: 1
      });

      syncedCount++;

    } catch (err) {
      console.error("❌ Failed syncing patient:", err.response?.data || err.message);
    }
  }

  return syncedCount; // 🔥 return how many were synced
}

export const getAllOfflinePatients = async (
  technicianId,
  packageId,
  campId
) => {
  const db = await openDB();

  return new Promise((resolve, reject) => {
    const tx = db.transaction("patients", "readonly");
    const store = tx.objectStore("patients");

    const request = store.getAll();

    request.onsuccess = () => {
      const filtered = request.result.filter(p =>
        p.technician == technicianId &&
        p.package == packageId &&
        p.camp == campId &&
        (p.synced === 0 || p.synced === 1)
      );

      resolve(filtered);
    };

    request.onerror = () => reject(request.error);
  });
};

export const cleanupConfirmedPatients = async (backendIds) => {
  const db = await openDB();
  const tx = db.transaction("patients", "readwrite");
  const store = tx.objectStore("patients");

  const request = store.getAll();

  request.onsuccess = () => {
    const records = request.result;

    records.forEach(record => {
      if (
        record.synced === 1 &&
        backendIds.has(record.patient_id)
      ) {
        console.log("🧹 Removing confirmed patient:", record.patient_id);
        store.delete(record.id);
      }
    });
  };

  return new Promise((resolve, reject) => {
    tx.oncomplete = resolve;
    tx.onerror = () => reject(tx.error);
  });
};